module.exports = __webpack_public_path__ + "img/childIcon.7b00b985.png";